<template>
  <div style="width: 100%; padding: 0.4em;">
    <div class="dropdown">
      <input :ref="'Input'+name" :name="name" :inputmode="noKeyboard ? 'none' : 'search'" :readonly="noKeyboard"
        @focus="showOptions()" @keyup="keyMonitor"
        v-model="searchFilter" :placeholder="placeholder"
        autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="done"
        @contextmenu.prevent @paste.prevent @copy.prevent @cut.prevent @drop.prevent @dragstart.prevent @selectstart.prevent
        @compositionupdate="compositionUpdate($event)"/>
      <p v-if="!searchFilter" class="counter">{{ filteredOptions.length }}</p>
      <img v-if="searchFilter" src="../assets/icons/cancel.svg" class="remove" @click="clearField">
      <div class="option" v-show="optionsShown"
        @touchstart.passive="dismissKeyboard"
        @wheel.passive="dismissKeyboard"
        @scroll.passive="dismissKeyboard">
        <div class="option-item"
          @click.prevent.stop="selectOption(option)"
          @keyup.enter.prevent.stop="selectOption(option)"
          v-for="(option, index) in filteredOptions" :key="index">
          <div v-if="displayText(option) !== null">{{ displayText(option) }} <span class="option-counter">{{ option.c }}</span></div>
        </div>
      </div>
      </div>
    </div>

</template>

<script>
export default {
  name: 'Dropdown',
  template: 'Dropdown',
  props: {
    title: { type: String },
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    val: {
      type: [String, Number, Object],
      required: false,
      default: null,
      note: 'Current Value'
    },
    options: {
      type: Array,
      required: true,
      default: [],
      note: 'Options of dropdown. An array of options with id and name',
    },
    counts: {
      type: Array,
      required: false,
      default: [],
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select an option',
      note: 'Placeholder of dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 0,
      note: 'Max items showing'
    },
    splitWords: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Split words on space'
    },
    startsWith:{
      type: Boolean,
      required: false,
      default: false,
      note: 'filters start with not just contains'
    },
    noKeyboard: {
      type: Boolean,
      required: false,
      default: false,
      note: 'When true, prevent virtual keyboard (readonly + inputmode=none)'
    },
  },
  data() {
    return {
      previousOpts: null,
      selected: null,
      optionsShown: false,
      searchFilter: '',
      disabled: false
    }
  },
  created() {
    //this.$emit('selected', this.selected);
    this.pHolder = this.placeholder
    this.syncFromProp(this.val)
  },
  mounted() {
    // Close dropdown when clicking/tapping outside (iPad friendly)
    this._outsideHandler = (e) => {
      const root = this.$el
      if (!root || root.contains(e.target)) return

      if (this.optionsShown) {
        this.closeOptions()
      }

      const inputEl = this.$refs["Input" + this.name]
      if (inputEl && document.activeElement === inputEl) {
        inputEl.blur()
      }
    }
    window.addEventListener('pointerdown', this._outsideHandler, true)
    window.addEventListener('touchstart', this._outsideHandler, true)
    window.addEventListener('click', this._outsideHandler, true)
  },
  unmounted() {
    if (this._outsideHandler) {
      window.removeEventListener('pointerdown', this._outsideHandler, true)
      window.removeEventListener('touchstart', this._outsideHandler, true)
      window.removeEventListener('click', this._outsideHandler, true)
      this._outsideHandler = null
    }
  },
  computed: {
    reset(){
      return this.$store.getters.getReset
    },
    filteredOptions() {
      if (!this.options) return []
      const limit = this.maxItem || 0
      let regOption
      if (this.startsWith) {
        regOption = new RegExp('^' + (this.searchFilter?.name || this.searchFilter || ''), 'i')
      } else {
        regOption = new RegExp(this.searchFilter?.name || this.searchFilter || '', 'ig')
      }
      const agg = new Map() // display -> { name, c }
      for (const option of this.options) {
        const display = this.displayText(option)
        if (display === null) continue
        if ((this.searchFilter?.length || this.searchFilter?.name?.length) && !display.match(regOption)) continue
        const cAdd = (option && typeof option === 'object' && 'c' in option) ? (Number(option.c) || 0) : 0
        if (agg.has(display)) {
          const o = agg.get(display)
          o.c = (Number(o.c) || 0) + cAdd
        } else {
          agg.set(display, { name: display, c: cAdd })
          if (limit > 0 && agg.size >= limit) break
        }
      }
      const out = Array.from(agg.values())
      const el = document.getElementsByName(this.name)?.[0]
      if (el) {
        el.placeholder = out.length === 1 ? this.cleanOption(out[0].name) : this.pHolder
      }
      return out
    }
  },
  methods: {
    displayText(option) {
      const isObj = option && typeof option === 'object'
      const raw = isObj ? (option.name ?? option.id ?? '') : (option ?? '')
      let s = raw != null ? String(raw) : ''
      if (this.splitWords) s = s.split(' ')[0]
      s = s.trim()
      if (!s) {
        return this.name === 'fName' ? '-' : null
      }
      const sl = s.toLowerCase()
      if (sl === 'unknown' || sl === 'undefined') return null
      return s
    },
    compositionUpdate(event){
      //alert("UPDATE")
     
      this.searchFilter = event.data
     
    },
    cleanOption(option) {
      option = option.name || option.id || option || '-'
      if (!option || option == "u" || option == "undefined" ) {
        option = "Unknown"
      }
      return option
    },
    dismissKeyboard() {
      const inputEl = this.$refs["Input" + this.name]
      if (inputEl && document.activeElement === inputEl) {
        inputEl.blur()
      }
    },
    syncFromProp(value) {
      const next = value == null ? '' : this.cleanOption(value)
      if (this.searchFilter === next) return
      this.searchFilter = next
      const applyVal = () => {
        const inputEl = this.$refs["Input" + this.name]
        if (inputEl) {
          inputEl.value = next
        }
      }
      if (this.$refs && this.$refs["Input" + this.name]) {
        applyVal()
      } else {
        this.$nextTick(applyVal)
      }
    },
    closeOptions(triggerParent = true) {
      if (this.optionsShown) {
        this.optionsShown = false
        if (triggerParent && this.$parent) {
          this.$parent.optionsShown = false
        }
      }
    },
    reopenField(){
      this.selected = {}
      this.closeOptions()
      this.disabled = false
      this.pHolder = this.placeholder
      this.$emit('selected', null);
    },
    clearField() {
      this.selected = {}
      this.searchFilter = ''
      this.closeOptions()
      this.disabled = false
      this.pHolder = this.placeholder
      this.$emit('selected', null);
    },
    wipeField() {
      this.previousOpts= null
     
      this.selected = {}
      this.searchFilter = ''
      //this.$emit('selected', null);
      this.closeOptions()
      this.disabled = false
      this.pHolder = this.placeholder
    },
    selectOption(option) {
      console.log("SELECT",option)
      this.selected = option
      this.closeOptions()
      const text = this.displayText(option) || ''
      this.searchFilter = text
      this.$refs["Input"+this.name].value = this.searchFilter
      if (this.name === 'fName' && text === '-') {
        this.$emit('selected', '-')
      } else {
        const raw = (option && typeof option === 'object') ? (option.name ?? option.id ?? '') : option
        this.$emit('selected', raw)
      }
      document.activeElement?.blur()
    },
    setOption(option) {
      this.selected = option.name || option;
      this.closeOptions()
      // this.searchFilter = this.selected;
       this.disabled = true
      this.$emit('selected', this.selected);
    },
    showOptions() {
      console.log("showOptions",this.disabled)
      if (!this.disabled) {
        // If there is an existing value, clear input locally without emitting
        if (this.searchFilter && String(this.searchFilter).length > 0) {
          this.wipeField()
          // Inform parent that this field was cleared, without triggering filtering logic
          this.$emit('cleared', this.name)
        } else {
          // Reset local state without notifying parent
          this.selected = {}
          this.optionsShown = false
          this.disabled = false
          this.pHolder = this.placeholder
        }
        this.optionsShown = true
        if (this.$parent) {
          this.$parent.optionsShown = true
        }

      } else {
        // In disabled mode, also avoid emitting while clearing UI
        this.wipeField()
        this.searchFilter = ''
        this.optionsShown = true;
        if (this.$parent) {
          this.$parent.optionsShown = true
        }
        // document.activeElement?.blur()
      }
    },
    exit() {
      console.log("EXIT",this.searchFilter)
      
      if(!this.searchFilter){
        this.closeOptions()
        return
      }
      if(this.filteredOptions && this.filteredOptions.length>0 ){
        const first = this.filteredOptions[0]
        const firstText = this.displayText(first) || ''
        const needle = (this.searchFilter && this.searchFilter.name) ? this.searchFilter.name : (this.searchFilter || '')
        if (firstText && isNaN(firstText)) {
          if (firstText.toLowerCase().indexOf(String(needle).toLowerCase()) === 0) {
            // Select the original option to keep object payload when present
            this.selectOption(first)
          }
        }
      }else{
        if(this.searchFilter!=""){
        alert("No "+this.placeholder+" matching "+this.searchFilter)
        this.clearField()
        }else{
          //alert("nothing to show")
           this.clearField()
        }
      }
      
    },
    // Selecting when pressing Enter
    keyMonitor: function (event) {
      //alert(event.which)
      if(event.which){
        //alert(this.searchFilter)
      }
      if (event.key === "Enter" && this.filteredOptions[0]) {
        const needleRaw = (this.searchFilter && this.searchFilter.name)
          ? this.searchFilter.name
          : (this.searchFilter || '')
        const needle = String(needleRaw).toLowerCase()

        const exactOption = needle
          ? this.options.find((option) => {
              const text = this.displayText(option)
              return text && text.toLowerCase() === needle
            })
          : null

        if (exactOption) {
          this.selectOption(exactOption)
        } else {
          const first = this.filteredOptions[0]
          const firstText = this.displayText(first) || ''
          const emitVal = (this.name === 'fName' && firstText === '-')
            ? '-'
            : ((first && typeof first === 'object') ? (first.name ?? first.id ?? '') : first)
          this.searchFilter = firstText
          this.$emit('selected', emitVal)
          document.activeElement?.blur()
        }
        //this.setOption(this.filteredOptions[0]);
      }
    }
  },
  watch: {
    reset(val){
      if(val){
        this.wipeField()
      }
    },
    val(newVal) {
      this.syncFromProp(newVal)
    },
    filteredOptions(val) {
    
      if (val.length > 1) {
        this.previousOpts = val.slice()
      } else {
        if (val.length == 0) {
          this.previousOpts
        }
       }
    },
    searchFilterX(val) {
      
      if (this.filteredOptions.length === 0) {
        this.selected = {};
      } else {
        this.selected = this.filteredOptions[0];
        this.disabled = true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
form {
  display: flex;
  position: relative;
}
label {
  width: clamp(100px, 25vw, 140px);
  min-width: clamp(100px, 25vw, 140px);
  height: 1.75em;
  margin-top: -12.5px;
  text-align: right;
  white-space: nowrap;
}
.smallDD#age {
  label {
    width: clamp(100px, 23vw, 118px);
    min-width: clamp(100px, 23vw, 118px);
  }
  .counter {
    color: transparent;
  }
}
.smallDD#gender {
  .counter {
    color: transparent;
  }
}
input {
  width: 100%;
  padding: 0.375em 10px 0.125em;
  border: none;
  border-radius: 5px;
  outline: none;
  box-sizing: border-box;
  background-color: var(--cool-sandstone);
  font-family: "DIN Condensed Bold", sans-serif;
  font-size: clamp(1.25em, 5vw, 1.75em);
  z-index: 2;
  -webkit-touch-callout: none; /* disable iOS callout */
  -webkit-user-select: none;
  user-select: none;
  touch-action: manipulation; /* reduce double-tap behaviors */
}
input:hover {
  background-color: var(--white);
}
input:focus {
  background-color: var(--white);
}
::placeholder { // Chrome, Firefox, Opera, Safari 10.1+
  color: var(--light-grey);
  opacity: 1; // Firefox
}
:-ms-input-placeholder { // Internet Explorer 10-11
  color: var(--light-grey);
}
::-ms-input-placeholder { // Microsoft Edge
  color: var(--light-grey);
}
.dropdown-container {
  display: flex;
  margin-bottom: 5px;
  margin-right: 5px;
  z-index: 5;
  position: relative;
}


.dropdown-box {
  width: 100%;
  max-height: 17.5em;
  position: absolute;
  top: 28px;
  left: 0px;
  box-shadow: 0 0 20px 5px var(--charcoal);
  border-radius: 0 0 5px 5px;
  border-top: 10px solid var(--light-grey);
  overflow: auto;
  z-index: 1;
}
.dropdown-item {
  font-size: clamp(1.25em, 5vw, 1.75em);
  line-height: 1.31em;
  padding: 0.4em 0.5em 0.2em;
  border-bottom: 1px solid var(--light-grey);
  text-align: left;
  display: block;
  color: var(--charcoal);
  background-color: var(--cool-sandstone);
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: var(--white);
  }
}
.dropdown-counter {
  position: absolute;
  right: 0px;
  color: var(--grey);
  margin-top: 0.125em;
  margin-right: 0.45em;
  font-size: 0.95em;
  z-index: 30;
}
.dropdown:hover .dropdowncontent {
  display: block;
}
.counter {
  position: absolute;
  right: 0px;
  color: var(--grey);
  margin: 0.6em 0.5em;
  font-size: clamp(0.9em, 5vw, 1.6em);
  line-height: 1em;
  z-index: 30;
}
.remove {
  width: clamp(1.6em, 6.5vw, 2.4em);
  position: absolute;
  right: 0px;
  margin: 0.25em;
  z-index: 2;
}
</style>
<style lang="scss" scoped>
.dropdown {
  display: flex;
  position: relative;
  flex-grow: 1;
}
.dropdown:hover .dropdowncontent {
  display: block;
}
input {
  width: 100%;
  padding: 0.1em 0.5em 0;
  color: var(--white);
  background-color: var(--light-charcoal);
  border: 2px solid var(--grey);
  border-radius: 0.25em;
  font-family: "Din", sans-serif;
  font-size: 1.5em;
  box-sizing: border-box;
  z-index: 2;
  -webkit-touch-callout: none; /* disable iOS callout */
  -webkit-user-select: none;
  user-select: none;
  touch-action: manipulation; /* reduce double-tap behaviors */
}
input:hover, input:focus {
  color: var(--white);
  background-color: var(--charcoal);
  border: 2px solid var(--cool-sandstone);
}
::placeholder { // Chrome, Firefox, Opera, Safari 10.1+
  color: var(--grey);
  opacity: 1; // Firefox
}
:-ms-input-placeholder { // Internet Explorer 10-11
  color: var(--grey);
}
::-ms-input-placeholder { // Microsoft Edge
  color: var(--grey);
}
.counter {
  position: absolute;
  right: 0;
  color: var(--grey);
  margin: 0.5em;
  z-index: 30;
}
.option {
  position: absolute;
  width: 100%;
  max-height: 16.65em;
  top: 48px;
  left: 0px;
  border-radius: 0.25em 0.25em 0.25em 0.25em;
  // border-top: 1em solid var(--cool-sandstone);
  box-shadow: 0 0 20px 5px var(--charcoal);
  overflow: auto;
  z-index: 3000;
  -webkit-overflow-scrolling: touch; /* smooth iOS momentum scrolling */
  overscroll-behavior: contain; /* prevent scroll chaining to page */
}
.option-item {
  font-family: "Din", sans-serif;
  font-size: 1.5em;
  padding: 0 0.5em;
  text-align: left;
  color: var(--charcoal);
  background-color: var(--cool-sandstone);
  border-bottom: 2px solid var(--grey);
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: var(--white);
  }
}
.option-counter {
  position: absolute;
  right: 0;
  color: var(--grey);
  margin-right: 0.5em;
  z-index: 30;
}
.remove {
  position: absolute;
  right: 0;
  margin: 0.5em;
  width: 2em;
  z-index: 20;
}
/* Hide iOS autofill accessory buttons (best effort) */
input::-webkit-contacts-auto-fill-button,
input::-webkit-credentials-auto-fill-button {
  visibility: hidden;
  display: none !important;
}
</style>
